import React from 'react'

export default function EmptyLine(props:{className?:string, width?: string}) {
  return (
    <div className={"EmptyLine " + (props.className??"")} style={{width: props.width ?? "95%"}}></div>
  )
}
